// タブ切り替え（通常）
// ----------------------------------------
function TAB_SWITCH (CONTENTS, MENU) {
  'use strict';

  var index = 0;

  if($.cookie('PARENT_TAB')) {
    index = $.cookie('PARENT_TAB');
    MENU.removeClass('is-active').eq(index).addClass('is-active');
    CONTENTS.hide().eq(index).show();
  }
  // CONTENTS.hide().eq(index).show(); // クッキー使わない場合

  MENU.on('click', function() {
    var _this = this;

    if(index != MENU.index(_this)) {
      index = MENU.index(_this);

      CONTENTS.hide().eq(index).show();
      MENU.removeClass('is-active').eq(index).addClass('is-active');


      $.cookie('PARENT_TAB', index, {
        expires: 1
      });

    }

    return false;
  });
}
